import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { legacyLogicalPropertiesTransformer, StyleProvider } from '@ant-design/cssinjs';
import store from './store';
import { ThemeContextProvider } from './contexts/themeContext';
import App from './components/app';
import "./index.scss";
import './i18n';

const Root = () => {
  return (
    <Provider store={store}>
      <ThemeContextProvider>
        <HashRouter>
          <StyleProvider hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]}>
            <App />
          </StyleProvider>
        </HashRouter>
      </ThemeContextProvider>
    </Provider>
  );
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);




